import React from "react";
import Hero from "../sections/Hero";
import About from "../sections/About";
import Products from "../sections/Products";
import Features from "../sections/Features";
import Presentation from "../sections/Presentation";
import Contact from "../sections/Contact";

function HomePage() {
  return (
    <>
      <Hero />
      {/* <About /> */}
      {/* <Products /> */}
      {/* <Features /> */}
      {/* <Presentation /> */}
      {/* <Contact /> */}
    </>
  );
}

export default HomePage;
